// Service for the Attendance Dashboard "Mi equipo" — "Situación de asistencia" section,
// "Ausentes" card (ASIS-5406 / REXASIS-005).
// GET /attendance/my-team/today/absence-summary?companyIds=1,2&employeeIds=10,15 —
// both query params are optional CSV lists; omitted/[] means "Todos" (no filter),
// scoped to the Empresa/Colaborador filters of the "Mi equipo" dashboard.

import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import { buildQueryString } from '@/api/shared';

import type {
  LC_GetTodayAbsenceSummaryOut,
  GetMyTeamAbsenceSummaryParams,
  MyTeamAbsenceSummary,
} from '../types/myTeamAbsenceSummary.types';
import { mapMyTeamAbsenceSummary } from '../mappers/myTeamAbsenceSummary.mapper';


export class MyTeamAbsenceSummaryService {
  async getSummary(
    params?: GetMyTeamAbsenceSummaryParams,
    signal?: AbortSignal,
  ): Promise<ApiResponse<MyTeamAbsenceSummary>> {
    const query = buildQueryString({
      companyIds: params?.companyIds?.map(String),
      employeeIds: params?.employeeIds?.map(String),
    });
    const endpoint = `${API_CONFIG.ENDPOINTS.ATTENDANCE_MY_TEAM_TODAY_ABSENCE_SUMMARY}${query}`;
    const response = await apiClient.get<LC_GetTodayAbsenceSummaryOut>(endpoint, { signal });

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    return { ...response, data: mapMyTeamAbsenceSummary(response.data) };
  }
}

export const myTeamAbsenceSummaryService = new MyTeamAbsenceSummaryService();
